import $ from 'jquery';
$(document).ready(function () {
    $('.section-client-stories .slide').each(function () {
        if (!$(this).hasClass('active')) {
            $(this).find('a').attr('tabindex', '-1');
        }
        else {
            $(this).find('a').attr('tabindex', '0');
        }
    });
    /**
       * Track the current clicked button class.
       * @type {String}
       */
    let clickedSliderNavButtonClass = '';
    /**
        *
        * @type {NodeListOf<HTMLDivElement>}
        */
    const slideNodes = document.querySelectorAll('.section-client-stories .slide');
    /**
        * The mutation configuration
        * @type {{attributesFilter: string[], attributes: boolean}}
        */
    const classMutationConfig = { attributes: true, attributeFilter: ['class'] };
    /**
        *
        * @param {HTMLDivElement} slide
        * @param {Boolean} makeTabbable
        */
    const toggleStateOfTabbableItemsInSlide = (slide, makeTabbable) => {
        /**
              *
              * @type {NodeListOf<HTMLAnchorElement>}
              */
        const slideLinks = slide.querySelectorAll('a');
        slideLinks.forEach((linkItem) => {
            linkItem.tabIndex = makeTabbable ? '0' : '-1';
        });
        /**
              * Get the slide nav buttons.
              * @type {NodeListOf<HTMLButtonElement>}
              */
        const slideNavButtons = document.querySelectorAll('.section-client-stories .slider-nav button');
        slideNavButtons.forEach((buttonItem) => {
            if (makeTabbable) {
                buttonItem.tabIndex = '0';
                if (buttonItem.classList.contains('inactive')) {
                    buttonItem.tabIndex = '-1';
                }
                if (buttonItem.classList.contains(clickedSliderNavButtonClass)) {
                    //buttonItem.focus();
                }
            }
            else {
                if (buttonItem.classList.contains('inactive')) {
                    buttonItem.tabIndex = '-1';
                }
            }
        });
    };
    /**
        * Callback function when a mutation happens.
        * We are looking for class mutation of active.
        * @param mutationsList
        * @param observer
        * @type {MutationCallback}
        */
    const onSlideActiveClassMutation = (mutationsList, observer) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes') {
                const observingClassNames = ['active'];
                if (mutation.target.classList.contains(observingClassNames)) {
                    toggleStateOfTabbableItemsInSlide(mutation.target, true);
                }
                else {
                    toggleStateOfTabbableItemsInSlide(mutation.target, false);
                }
            }
        }
    };
    /**
        * Set up the observer to watch for active class in slide
        */
    const observeForActiveClassMutations = () => {
        if (slideNodes && slideNodes.length > 0) {
            slideNodes.forEach((slideItem) => {
                const observer = new MutationObserver(onSlideActiveClassMutation);
                //Observe for class mutations
                observer.observe(slideItem, classMutationConfig);
            });
        }
    };
    /**
        *
        * @type {NodeListOf<Element>}
        */
    const sliderPrevButtons = document.querySelectorAll('.section-client-stories .slider-prev');
    /**
        *
        * @type {NodeListOf<Element>}
        */
    const sliderNextButtons = document.querySelectorAll('.section-client-stories .slider-next');
    if (sliderPrevButtons && sliderPrevButtons.length > 0) {
        sliderPrevButtons.forEach((sliderPrev) => {
            sliderPrev.addEventListener('click', (e) => {
                if (e.target instanceof HTMLButtonElement) {
                    clickedSliderNavButtonClass = 'slider-prev';
                }
            });
        });
    }
    if (sliderNextButtons && sliderNextButtons.length > 0) {
        sliderNextButtons.forEach((sliderNext) => {
            sliderNext.addEventListener('click', (e) => {
                if (e.target instanceof HTMLButtonElement) {
                    clickedSliderNavButtonClass = 'slider-next';
                }
            });
        });
    }
    observeForActiveClassMutations();
});
